module.exports = __webpack_public_path__ + "static/media/liberty.78393cbe.jpg";